import * as React from 'react';

import { NodeProps, Position } from '@xyflow/react';
import { Webhook } from 'lucide-react';

import { BaseNode } from '../../BaseNode';
import type { NodeVisualDefinition, TriggerNode } from '../../types';

import {
  HttpWebhookTriggerConfigType,
  getHttpWebhookTriggerPreviewText,
} from './schema';

/** Typed node for HTTP webhook trigger */
type HttpWebhookTriggerNodeType = TriggerNode<HttpWebhookTriggerConfigType>;

/** Visual definition for the HTTP Webhook Trigger node */
export const httpWebhookTriggerVisualDefinition: NodeVisualDefinition = {
  key: 'HttpWebhookTrigger',
  label: 'HTTP Webhook',
  description: 'Trigger via external HTTP POST request',
  icon: Webhook,
  color: 'warning',
  handles: [
    {
      type: 'source',
      position: Position.Bottom,
      className: 'bg-gray!',
    },
  ],
  getContent: getHttpWebhookTriggerPreviewText as (
    config: Record<string, unknown>,
  ) => string,
};

/**
 * Visual component for HTTP Webhook Trigger nodes on the canvas.
 */
export const HttpWebhookTriggerNode = React.memo<
  NodeProps<HttpWebhookTriggerNodeType>
>((props) => (
  <BaseNode
    {...props}
    definition={httpWebhookTriggerVisualDefinition}
    className="@HttpWebhookTriggerNode"
  />
));

HttpWebhookTriggerNode.displayName = 'HttpWebhookTriggerNode';
